<template>
  <BaseConfirm :visible="visible" icon-type="badge" title="Login ke Office Lain" message="Masukkan Kode Office Lain"
    confirm-text="Login" type="success" size="max-w-lg" :loading="loading" :disabled="!code" @opened="code = null"
    @close="$emit('close')" @confirmed="onConfirmed">
    <template #content>
      <BaseInput inset label="Kode Office" placeholder="AB.001" type="text" v-model="code" />
    </template>
  </BaseConfirm>
</template>

<script>
import { mapActions } from 'vuex';
import { requestMixin } from '../../mixins/request/request.js';
import BaseConfirm from '../base/BaseConfirm.vue';

export default {
  mixins: [requestMixin],
  components: { BaseConfirm },
  props: {
    visible: Boolean
  },
  emits: ['close'],
  data() {
    return {
      code: null,
      loading: false
    }
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert'
    }),
    async onConfirmed() {
      this.loading = true

      const [, err] = await this.request(`/api/v1/login-as`, {
        method: 'post',
        data: {
          code: this.code
        }
      })

      if (err) {
        this.createAlert({
          status: 'error',
          data: 'Superuser tidak aktif'
        })
      } else {
        window.location.href = '/'
      }

      this.loading = false
    }
  }
}
</script>